import { type PartialPropsOf } from '@blaze-runtime/engine-domain';

import { migrateFontBoldStyleToFontWeightMutably } from '../../../services/compat/migration.helpers';
import { type PropsMigration } from '../../../services/compat/migrations/layout-migration.models';

export const datetimeInputV2Migration: PropsMigration = {
  mode: 'props',
  description: 'Migrate datetime input font bold style to font weight',
  run: (props: PartialPropsOf<'datetimeInput'>): void => {
    migrateFontBoldStyleToFontWeightMutably(props?.style?.inputFont);
  },
};
